import { Component, Input } from '@angular/core';

import { BaseFormControl } from '../base-control';
import { FormGroupField } from '../form-field';
@Component({
    standalone: false,
    selector: 'abs-form-group-base',
    template: ''
})
export class BaseFormGroupComponent extends BaseFormControl {
    field: FormGroupField;
}
